<template>
  <div>
    <global-header @search-click="searchClick" />

    <HomeNav :nav-list="navList" :sub-nav-list="subNavList"/>

    <HomeBanner :banner-list="bannerList" />

    <!-- <div class="home-image-banner"></div> -->

    <Notice class="notice"/>

    <div class="washington">
      <Washington :washington-props="washington" />
    </div>

    <div class="middleBanner">
      <MiddleBanner />
    </div>

    <div class="beijing">
<!--      <new-york :new-york-prpos="newYork" />-->
      <beijing :beijing-list="beijingList" />
    </div>

    <div class="los-angeles">
      <los-angeles :la-props="la" />
    </div>

    <div class="chengdu">
      <chengdu :chengdu="chengdu"/>
    </div>

    <div class="shanghai">
      <shanghai :shanghai="shanghai"/>
    </div>

    <div class="bottom-wrapper">
      <global-bottom />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GlobalHeader from '@/components/GlobalHeader'
import HomeNav from '@/components/HomeNav'
import HomeBanner from '@/components/HomeBanner'
import Washington from '@/components/Washington'
import LosAngeles from '@/components/LosAngeles'
import GlobalBottom from '@/components/GlobalBottom'
import Beijing from '../components/Beijing'
import Shanghai from '../components/Shanghai'
import Chengdu from '../components/Chengdu'
import MiddleBanner from '../components/MiddleBanner'
import Notice from '../components/Notice'
import { orgId, requestUrl } from '../common/constant'

export default {
  name: 'Home',
  components: {
    GlobalHeader,
    HomeNav,
    HomeBanner,
    MiddleBanner,
    Washington,
    LosAngeles,
    GlobalBottom,
    Beijing,
    Shanghai,
    Chengdu,
    Notice
  },
  data () {
    return {
      navList: [],
      subNavList: [],
      bannerList: [],
      washington: {},
      newYork: {},
      chengdu: {},
      la: [],
      beijingList: {},
      shanghai: {}
    }
  },
  async created () {
    await this.init()
  },
  methods: {
    async init () {
      await this.queryNavList()
      await this.queryBannerList()
      await this.queryWashington()
      await this.queryChengdu()
      await this.quertBeijing()
      await this.queryLosAngeles()
      await this.queryShanghai()
    },
    async queryNavList () {
      const result = await axios.get(`${requestUrl}/nav/${orgId}`)
      this.navList = result.data
      const idList = []
      this.navList.forEach(item => {
        idList.push(item.colmun_id)
      })
      const subList = await axios.get(`${requestUrl}/dnjt/nav/column?idList=${idList}`)
      subList.data.forEach(item => {
        this.subNavList.push(item)
      })
    },
    async queryBannerList () {
      const result = await axios.get(`${requestUrl}/banner/getBannerList?bannerTitle=banner-1&orgId=${orgId}`)
      result.data.forEach((item, index) => {
        if (item.img === '' || item.img === null) {
          result.data.splice(index, 1)
        }
      })
      this.bannerList = result.data
    },
    async quertBeijing () {
      const left = await axios.get(`${requestUrl}/news/getNewsList?blockCode=content-left&orgId=${orgId}`)
      const middle = await axios.get(`${requestUrl}/news/getNewsList?blockCode=content-middle&orgId=${orgId}`)
      const right = await axios.get(`${requestUrl}/news/getNewsList?blockCode=content-right&orgId=${orgId}`)
      this.$set(this.beijingList, 'leftList', left.data)
      this.$set(this.beijingList, 'middleList', middle.data)
      this.$set(this.beijingList, 'rightList', right.data)
    },
    async queryWashington () {
      // 获取前五个有图片的新闻
      const banner = await axios.get(`${requestUrl}/banner/312?offset=0&limit=5`)
      // 获取轮播图
      // const banner = await axios.get(`${requestUrl}/banner/getBannerList?bannerTitle=banner-2&orgId=${orgId}`)
      // 获取新闻列表
      const news = await axios.get(`${requestUrl}/news/getNewsList?blockCode=news-content&orgId=${orgId}`)
      this.$set(this.washington, 'bannerList', banner.data)
      this.$set(this.washington, 'newsList', news.data)
    },
    async queryChengdu () {
      const leftList = await axios.get(`${requestUrl}/news/getNewsList?blockCode=zgyy&orgId=${orgId}`)
      const middleList = await axios.get(`${requestUrl}/news/getNewsList?blockCode=xxyd&orgId=${orgId}`)
      // 获取专题专栏
      const themeList = await axios.get(`${requestUrl}/news/getNewsList?blockCode=special-new&orgId=${orgId}`)
      this.$set(this.chengdu, 'themeList', themeList.data)
      this.$set(this.chengdu, 'leftList', leftList.data)
      this.$set(this.chengdu, 'middleList', middleList.data)
    },
    async queryLosAngeles () {
      const result = await axios.get(`${requestUrl}/news/getNewsList?blockCode=bottom-list&orgId=${orgId}`)
      this.la = result.data
    },
    async queryShanghai () {
      const result = await axios.get(`${requestUrl}/news/getNewsList?blockCode=video-content&orgId=${orgId}`)
      this.shanghai = result.data
    },
    searchClick (keywords) {
      this.$router.push({
        path: '/news/312',
        query: {
          keywords: keywords
        }
      })
    }
  }
}
</script>

<style scoped>
.home-image-banner {
  background-image: url('../../public/imgs/home-banner-thrid.jpg');
  background-size: 100% 100%;
  width: 100%;
  height: 100px;
}
.washington {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 40px 0;
  border-bottom: 1px solid #ccc;
  background-color: #e3e4e5;
}

.notice {
  display: flex;
  align-items: center;
  justify-content: center;
}

.middleBanner {
  display: flex;
  align-items: center;
  justify-content: center;
}

.beijing {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px 0;
}

.los-angeles {
  padding: 20px;
  background-color: #e3e4e5;
  display: flex;
  align-items: center;
  justify-content: center;
}

.chengdu {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}

.bottom-wrapper {
  margin-top: 20px;
}

.shanghai {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
}
</style>
